/** @jsxImportSource theme-ui */
import { useEffect, useState } from "react";
import { Box } from "theme-ui";
import Icon from "./common/Icon";

interface StarRatingProps {
  onRate?: (rating: number) => void;
  currentRating?: number;
}

const StarRating = ({ onRate, currentRating }: StarRatingProps) => {
  const [rating, setRating] = useState(currentRating ?? 0);

  /**
   * We need useEffect hook to render again stars when rating is changed without pressing on it
   */
  useEffect(() => {
    setRating(currentRating ?? 0);
  }, [currentRating]);

  const handleRating = (starIndex: number) => {
    const calculatedRating = starIndex; // Convert index to half-star scale
    setRating(calculatedRating);
    if (onRate) {
      onRate(calculatedRating); // Trigger callback with the new rating
    }
  };


  return (
    <Box sx={{ display: "flex", gap: 2, mt: 6 }}>
      {Array.from({ length: 10 }, (_, index) => (
        <Box
          key={index}
          onClick={() => handleRating(index + 1)}
          sx={{ cursor: "pointer" }}
        >

          <Icon
            name={index < rating ? "star-filled" : "star"}
            size={20}
            color={index < rating ? "gold" : "tertiaryText"}
            sx={{
              transition: "color 0.4s",
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default StarRating;
